export enum TYPE_OF_VALUE {
  PERCENTAGE = "percentage",
  AMOUNT = "amount",
}
